import { createContext, useContext } from 'react';

import type { DocumentUploadSectionContextValue } from './types';

export const DocumentUploadSectionContext = createContext<DocumentUploadSectionContextValue | null>(
  null,
);

export function useDocumentUploadSectionContext(): DocumentUploadSectionContextValue {
  const value = useContext(DocumentUploadSectionContext);
  if (value === null) {
    throw new Error('Document upload section hooks must be used inside a <DocumentUploadSection>.');
  }
  return value;
}
